import { Component, OnInit, Input } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';
import { SearchService } from '../../../services/search.service';
import { NotifierService } from 'angular-notifier';
@Component({
  selector: 'app-resource-list-single',
  templateUrl: './resource-list-single.component.html',
  styleUrls: ['./resource-list-single.component.css']
})
export class ResourceListSingleComponent implements OnInit {
private readonly notifier: NotifierService;
  	constructor( private homepageService: HomepageService,private searchService: SearchService, notifierService: NotifierService ) {
        this.notifier = notifierService;
    }
  	resourcelists: any = [];
	@Input() rid: number;
  @Input() rsize: number;
	@Input() buId: number;
  	ngOnInit() {
 		this.getresourcelistsSingle();
 	}

    slideConfig = {
    "slidesToShow": 6,
    'autoplay': true,
    'autoplaySpeed': 3000,
    'dots': true,
    'vertical' : false,
    'prevArrow' : '<button class="slickArrowpre slick-arrow" aria-label="Previous" type="button" style=""><i class="fas fa-chevron-left"></i></button>',
    'nextArrow' : '<button class="slickArrownxt slick-arrow" aria-label="Previous" type="button" style=""><i class="fas fa-chevron-right"></i></button>',
    'responsive': [
        {breakpoint: 1281,settings: {slidesToShow: 4} },
        {breakpoint: 992,settings: {slidesToShow: 2} },
        {breakpoint: 768,settings: {slidesToShow: 1} }
        ] 
  }

     slickInit(e) {
     //console.log('slick initialized');
  }
 	
 	getresourcelistsSingle(){
    let getwidgetsSettingDataSave =  this.homepageService.getwidgetsSettingDataSave();
     getwidgetsSettingDataSave.data.forEach(evt => {
            if(evt.code == 'RL' && this.buId  == evt.id){
               this.resourcelists = evt;              
             }            
          });  
    }

  
  imageError(event,images){
    if(typeof($('body').find('span.RL').find('img[custom="'+event+'"]').attr('index')) != 'undefined' &&  parseInt($('body').find('span.RL').find('img[custom="'+event+'"]').attr('index')) > 0 ){
      var index:number = parseInt($('body').find('span.RL').find('img[custom="'+event+'"]').attr('index'));
      if(typeof($('body').find('span.RL').find('img[custom="'+event+'"]').attr('loaded')) != 'undefined')
      index--;
      this.imageLoad(event, images,index, true);
    } else {
      $('body').find('span.RL').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('span.RL').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('span.RL').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
      $('body').find('span.RL').find('img[custom="'+event+'"]').remove();  
      $('body').find('#'+event).remove();        
    }
  }
  
  imageLoad(event, images,index, fromError = false) {
    if($('body').find('span.RL').find('img[custom="'+event+'"]').attr('loaded') == 'yes' && !fromError) {
      return false;
    }
    if($('body').find('#'+event).length <= 0) {
       $('body').append('<img id="'+event+'" src="" style="display:none;">');
    }
    var $this = this;
    var imagesAll = this.searchService.sortedImage(images);
    $('#'+event).attr('src',imagesAll[index]);
    setTimeout(function(){
      var tempWidth = $('#'+event).width();
      //console.log(tempWidth, event, index);
      var temp = document.getElementById(event);
      if(tempWidth <= 1 && index > 0){
        $this.imageLoad(event,images,index-1, true);
        return false;
      }else if(tempWidth <= 1 && index == 0){
        $('body').find('span.RL').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('span.RL').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('span.RL').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
        $('body').find('span.RL').find('img[custom="'+event+'"]').remove();
      }
    },500);
    if(typeof(imagesAll[index]) != 'undefined') {
      $('body').find('span.RL').find('img[custom="'+event+'"]').attr('src',imagesAll[index]);
      $('body').find('span.RL').find('img[custom="'+event+'"]').attr('loaded','yes');        
      $('body').find('span.RL').find('img[custom="'+event+'"]').attr('index',index);        
    }
  }
}
